export default "__VITE_ASSET__BLdHm9ev__"